/**
 * Virtual Showrooms launch switch. One constant covers the anonymous
 * /showrooms/* routes, the member /home/showrooms/* routes and the sidebar
 * entry. Live everywhere since 2026-09-29; set to `false` to pull the feature.
 */
export const SHOWROOMS_ENABLED: boolean = true;
